(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('offers-bar-component')) {
    class OffersBarComponent extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.index = 0;
        this.timer = null;
        this.autoplay = this.dataset.autoplay === 'true';
        this.speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (this.slides.length < 2) return;

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.step(-1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.step(1, true));

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());

        // Theme editor: show the block being edited
        this.onBlockSelect = (e) => {
          const i = this.slides.indexOf(e.target);
          if (i > -1) { this.stop(); this.show(i); }
        };
        this.onBlockDeselect = () => this.start();
        this.closest('.shopify-section')?.addEventListener('shopify:block:select', this.onBlockSelect);
        this.closest('.shopify-section')?.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      show(i) {
        this.index = (i + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, n) => {
          slide.setAttribute('aria-hidden', n === this.index ? 'false' : 'true');
        });
      }

      step(dir, userInitiated = false) {
        this.show(this.index + dir);
        if (userInitiated) this.start();
      }

      start() {
        this.stop();
        if (!this.autoplay || this.reducedMotion) return;
        this.timer = setInterval(() => this.step(1), this.speed);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
    customElements.define('offers-bar-component', OffersBarComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
